'use client';

import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
import LoginForm from '~/components/LoginForm';
import LoginError from '~/components/LoginError';

interface ElectionLoginPageProps {
    error: boolean;
    loading: boolean;
}

const ElectionLoginPage = (props: ElectionLoginPageProps) => {
    const { error, loading } = props;

    if (loading) {
        return null;
    }

    return (
        <div className="responsive-main-container w-full ml-auto mr-auto container main-content text-[82%] pb-[100px] mt-[30px]">
            <p className="mb-4">
                <b>LOGG INN</b>
            </p>
            <div className="leading-[20px] my-[5px] mb-[30px]">Logg inn med ditt brukernavn/passord</div>

            <LoginForm />

            {error && <LoginError />}
        </div>
    );
};

const ElectionLoginPageWithStore = () => {
    const { loginPageStore, userStore } = getStore();

    return (
        <ElectionLoginPage
            error={loginPageStore.loginErrorUserPwd}
            loading={userStore.isLoggingOut || !userStore.isInitialized}
        />
    );
};

export default observer(ElectionLoginPageWithStore);
